module.exports = __webpack_public_path__ + "static/media/img-raffle-info-3.74559983.png";